import { Button, Icon } from '@chakra-ui/react';
import { FaYoutube } from 'react-icons/fa6';
import { TbBrandYoutube, TbBrandYoutubeFilled } from 'react-icons/tb';

const YouTubeButton = (props: { url: string, size: string }) => {

    return (
        <>
            {props.size === 'lg' ? (
                <Button borderWidth={'1px'} px='40px' py='40px' onClick={() => { window.open(props.url, '_blank'); }}><Icon as={FaYoutube} boxSize={14} color='red' me='20px' />Quick start guide</Button>
            ) : (
                <Button borderWidth={'1px'}  onClick={() => { window.open(props.url, '_blank'); }}><Icon as={TbBrandYoutube} boxSize={8} color='red' me='20px' />Quick start </Button>
            )}

        </>
    )
}

export default YouTubeButton